import { AthleteI } from 'types';

import { useHCXFinancialCardContext } from '../../hcx-financial-card-context';

export const useAthleteCareerDescription = (): { description: string; id: AthleteI['id'] } => {
  const { athlete } = useHCXFinancialCardContext();

  return { description: athlete?.career?.description || '', id: athlete?.id ?? 0 };
};
